import React, {useState} from "react";
import styled from "styled-components";
import Modal from '../../../../../../components/modal';
import { TrainerButton } from './assign-trainer-button'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const BulkAssignTrainer = ({assignType, open, onClose, handleSubmit, isLoading, disabled}) => {
  const [linkData, setLinkData] = useState('');
  return (
    <Modal
      title={assignType === 'assign' ? "Assign trainer" : "Remove trainer"}
      submitLabel="Confirm"
      open={open}
      onClose={() => {setLinkData(''); onClose();}}
      handleSubmit={() => { if (linkData?.id) handleSubmit(linkData.id)}}
      disabled={disabled}
      isLoading={isLoading}
    >
      <Container>
        <TrainerButton
          linkData={linkData}
          setLinkData={setLinkData}
        />
      </Container>
      {/* <p>If a client's next check-in is within the next 5 days, their next check-in will be pushed a week later.</p> */}
    </Modal>
  );
};
